import { CheckNotes, InspectionCase } from '../inspection-cases';
import { GasExtinguishingMain } from './gas-extinguishing-main.dto';
import { GasSystemArea } from './gas-system-area.dto';

export class GasExtinguishingSystemDesignDto extends InspectionCase {
  main?: GasExtinguishingMain;
  areas?: GasSystemArea[];
}

export class GasExtinguishingSystemDesign extends GasExtinguishingSystemDesignDto {
  constructor(
    data: GasExtinguishingSystemDesignDto = {
      title: 'תכנון / התקנה',
      isApplicable: true
    }
  ) {
    super(data);
    this.main = new GasExtinguishingMain(data.main);
    this.areas = data.areas
      ? data.areas.map((item) => new GasSystemArea(item))
      : [new GasSystemArea()];
  }

  setInspectionStatus(): void {
    this.main.setInspectionStatus();
    this.areas.forEach((item) => item.setInspectionStatus());
    this.isPassed = this.main.isPassed && this._isPassed();
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.main.getNotes()];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.main.setAsApplicable();
    this.areas.forEach((area) => area.setAsApplicable());
  }

  private _isPassed(): boolean {
    return !this.areas.some((item) => item.isApplicable && !item.isPassed);
  }
}
